import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const MenuProps = {
  PaperProps: {}
};

export default function FiltersMultiSelect({ options, changeHandler, selectedFilter, setSelectedFilter }) {
  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    setSelectedFilter({
      ...selectedFilter,
      [options.name]: value
    });
    changeHandler(event);
  };

  return (
    <FormControl variant="outlined" size="small">
      {selectedFilter[options.name].length === 0 && (
        <InputLabel shrink={false} sx={{ '&.MuiInputLabel-root.Mui-focused': { color: 'black', opacity: 0.6 } }}>
          {options.label}
        </InputLabel>
      )}
      <Select
        value={selectedFilter[options.name]}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'Without label' }}
        disableUnderline
        IconComponent={ExpandMoreIcon}
        sx={{
          // minHeight: '35px',
          width: '150px',
          boxShadow: 'none',
          background: '#d1d3d4',
          borderRadius: '5px',
          border: '1px solid #d1d3d4',
          '& .MuiSelect-icon': {
            marginRight: '3px'
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '& .MuiInputLabel-root': {
            fontSize: '14px'
          }
        }}
        multiple
        input={<OutlinedInput label={options.name} />}
        renderValue={(selected) => selected.join(', ')}
        MenuProps={MenuProps}
      >
        {options?.options?.map((item, index) =>
          index > 0 ? (
            <MenuItem key={item?.key} value={item?.label}>
              <Checkbox checked={selectedFilter[options.name].indexOf(item?.label) > -1} />
              <ListItemText primary={item?.label} />
            </MenuItem>
          ) : (
            false
          )
        )}
      </Select>
    </FormControl>
  );
}
